import "../../../../styles/OrderProducListCard.scss";

import Icon, { iconTypes } from "../../../common/components/Icon";
import { Tag, tagTypes } from "../../../common/components/Tag";

import CounterField from "../../../common/components/CounterField";
import { Localization } from "../../../common/util/localization.jsx";
import ProductView from "../product/ProductView";
import PropTypes from "prop-types";
import React from "react";
import { scssVariables } from "../../../common/util/config.jsx";
import { withRouter } from "react-router-dom";

class CampaignCard extends React.PureComponent {
    constructor(props){
        super(props);

        this.state = {
            expanded: false,
        };

        this.expand = this.expand.bind(this);
        this.collapse = this.collapse.bind(this);
    }

    expand(){
        this.setState({
            expanded: true,
        });
    }
    collapse(){
        this.setState({
            expanded: false,
        });
    }

    render() {
        const {
            localization,
            activeOrder,
            products,
            width,
            labelName,
            campaignPeriod,
            deviceType,
            addRemoveProductToTemporaryOrder,
            setModal,
        } = this.props;
        //size of left info window 
        const marginLeft = `${deviceType==="xs"?2:(deviceType==="sm"?4:16)}px`;
        //remaining width removin padding used for card
        const widthLeft = width;

        const isTinyDevice = deviceType==="sm" || deviceType==="xs" || deviceType==="md";

        return (
            <React.Fragment>
                <div className="card-default">
                    <div className="my-list-menu" style={{width:`${width}px`,flexWrap:isTinyDevice?"wrap":undefined}}>
                        <label className="header">
                            {labelName}
                        </label>
                        <label className="header-small">
                            {campaignPeriod}
                        </label>
                        <div className="controllers">
                            {!isTinyDevice && (
                                <div className="tag">
                                    <Tag label={localization.text("order","countProducts",{count:products.length})} type={tagTypes.red} />
                                </div>
                            )}
                            <div className="space"/>
                            <button className="btn circular" onClick={this.state.expanded?this.collapse:this.expand} style={{marginLeft:marginLeft}}>
                                <Icon type={this.state.expanded?iconTypes.up:iconTypes.down} />
                            </button>
                        </div>
                    </div>
                    {this.state.expanded && (
                        <div className="list-prd" style={{width:`${widthLeft}px`}}>
                            <ProductView
                                activeOrder={activeOrder}
                                localization={localization}
                                view={deviceType==="xs"?"list":"item"}
                                style={{maxHeight: isTinyDevice?"300px":"600px", minHeight: scssVariables.prdListItemHeight}}
                                list={products}
                                isLoading={false}
                                loadMoreProducts={undefined}
                                deviceType={deviceType}
                                addRemoveProductToTemporaryOrder={addRemoveProductToTemporaryOrder}
                                setModal={setModal}
                                countingNode={<CounterField/>}
                            />
                        </div>
                    )}
                </div>
            </React.Fragment>
        );
    }
}


CampaignCard.propTypes = {
    //Required
    campaignId: PropTypes.number.isRequired,
    deviceType: PropTypes.string.isRequired,
    localization: Localization.propTypes.isRequired,
    activeOrder: PropTypes.object.isRequired,
    productView: PropTypes.object.isRequired,
    addRemoveProductToTemporaryOrder: PropTypes.func.isRequired,
    width: PropTypes.number.isRequired,
    products: PropTypes.array.isRequired,
    labelHeader: PropTypes.string.isRequired,
    labelName: PropTypes.string.isRequired,
    campaignPeriod: PropTypes.string.isRequired,
    history: PropTypes.object.isRequired,
    setModal: PropTypes.func.isRequired,
};

export default withRouter(CampaignCard);